import axios from 'axios';

const api = axios.create({
  baseURL: '',
  headers: { 'Content-Type': 'application/json' },
});

// Attach JWT token to every outbound request.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// On 401, clear stored credentials and redirect to /login — but only when an
// existing session has expired (i.e. we HAD a token).  If there is no stored
// token the user is simply unauthenticated; redirecting would break public
// pages like /register that make optional API calls before login.
// Also skip auth endpoints themselves (login returns 401 on bad password and
// we must not create an infinite redirect loop).
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const isAuthEndpoint = error.config?.url?.startsWith('/api/auth/');
    const hadToken = !!localStorage.getItem('token');
    if (error.response?.status === 401 && !isAuthEndpoint && hadToken) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
